/**
 * @Author: Simon
 */

import React from "react";
import {
    Table, Button, Modal, Spin, message, Input, Radio, TreeSelect, Select,
    Divider, Icon, Row, Col, Checkbox, DatePicker, Dropdown, Menu, Form, Tooltip
} from 'antd';
import { connect } from "react-redux";
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import traningGroupService from '../../services/Training/traning-group-service.js';
import { fetchDepartmentsList } from '../../actions/department-structure-actions.js';

class TraningGroup extends React.Component {
    
    pageExist = true;
    state = {
        data: [],
        pageStatus: "unload",
        filters: {
            page: 1,
            group_name: "",
        },
        selectedIDs: [],
        modalVisible: false,
        modelName: "",
        currentData: {},
        submitAction: "",
        department: [],
        currentData: {}
    }
    //组建加载前
    componentWillMount() {
        this.initializePage();
        this.initializeDepartment();
    }
    componentDidMount() {
        this._fetchDepartmentsList()
    }
    _fetchDepartmentsList = (params) => {
		this.props.fetchDepartmentsList(params);
	}
    //页面初始化
    initializePage = () => this.setState({
        pageStatus: "reload"
    }, () => {
        const filters = {};
        for (let key in this.state.filters) {
            if (this.state.filters[key]) {
                filters[key] = this.state.filters[key];
            }
        }
        traningGroupService.fetchTraningGroupList(filters, result => {
            if (this.pageExist) {
                this.setState({
                    pageStatus: "loaded",
                    data: result.data
                })
            }
        })
    });
    //部门初始化
    initializeDepartment = () => {
        this.setState({ department: this.props.departmentStructure });
    }
    //组建加载后
    componentWillUnmount() {
        this.pageExist = false;
    }
    //table 列配置
    columns = [{
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        className: "table-global-head-small",
        render: (text, record, index) => { return index + 1 }
    }, {
        title: '群组名称',
        dataIndex: 'name',
        key: 'name',
        className: "table-global-head-small"
    }, {
        title: '分组内人数',
        dataIndex: 'member_count',
        key: 'member_count',
        className: "table-global-head-small"
    }, {
        title: '创建时间',
        dataIndex: 'create_time',
        key: 'create_time',
        className: "table-global-head"
    }, {
        title: '操作',
        dataIndex: 'action',
        className: "table-global-head-tiny",
        key: 'action',
        render: (text, record, index) => (
            <span>
                {this.props.access.tranningGroup.u_value && <Button icon="edit" size="small" onClick={this.handleEdit.bind(this, record.id)} >编辑</Button>}
            </span>
        ),
    }];

    //增删改查
    //1.0新增

    //2.0修改
    handleEdit = id => {
        if (id) {
            this.setState({
                submitAction: "edit",
                currentData:
                {
                    ...this.state.currentData,
                    id: id
                }
            });
            let params = { modelId: id };
            traningGroupService.fetchTraningGronpDetail(params, result => {
                this.setState({ department: result.data })
            });
            this.showModal('modalVisible', "编辑群组");
        }
    }


    //show出指定名称的Model
    showModal = (para, modelName) => {
        this.setState({
            modelName: modelName,
            [para]: true
        });
    }

    //点击某行事件
    rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            let ids = selectedRows.map(row => row.id);
            this.setState({ selectedIDs: ids });
        }
    }

    //翻页事件
    setPageFilter = pagination => {
        this.setState({
            filters: {
                ...this.state.filters,
                page: pagination.current
            }
        }, this.initializePage)
    }
    //切换model状态
    toggleModal = () => this.setState({
        modalVisible: !this.state.modalVisible
    })
    //model提交事件
    submitCurrentData = () => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                const posts = {
                    ...this.state.currentData,
                    ...values
                }
                if (this.state.submitAction == "add") {

                } else if (this.state.submitAction == "edit") {
                    traningGroupService.editTraningGroup(posts);
                }
            }
        })
    }
    //加载树
    renderTreeNodes = data => data.map(item => {
        if (item.children) {
            return (
                <TreeSelect.TreeNode title={item.name}
                    value={item.name}
                    key={item.id}
                    dataRef={item} >
                    {item.children.length !== 0 && this.renderTreeNodes(item.children)}
                </TreeSelect.TreeNode>
            )
        }
        return <TreeSelect.TreeNode {...item} />
    })

    render() {
        return (
            <div className="app-module-item">
                <div style={{ float: "left" }}>
                    {this.props.access.tranningGroup.c_value &&
                        <Button style={{ margin: "0px 5px 10px 0px" }}
                            type="primary" icon="plus-circle-o">
                            新增</Button>}
                </div>
                <div style={{ float: "left" }}>
                    {this.props.access.tranningGroup.d_value &&
                        <Button style={{ margin: "0px 5px 10px 0px" }}
                            type="primary" icon="minus-circle-o">
                            删除</Button>}
                </div>
                <div style={{ float: "left" }}>
                    {this.props.access.tranningGroup.d_value &&
                        <Button style={{ margin: "0px 5px 10px 0px" }}
                            type="primary" icon="cloud-download-o">
                            导出</Button>}
                </div>
                <div style={{ float: "right" }}>
                    <Input.Search style={{ width: 200, margin: "0px 5px 10px 0px" }}
                        placeholder="群组名称"
                        onSearch={this.initializePage}
                        value={this.state.filters.group_name}
                        // onChange={this.setEmployeeFilter}
                        enterButton />
                </div>
                <div style={{ clear: "both" }}></div>
                <Divider style={{ margin: "7px 0px 10px" }} />
                <div>
                    {("unload" === this.state.pageStatus || "reload" === this.state.pageStatus) &&
                        <div style={{ textAlign: 'center', margin: '100px 0px' }}>
                            <Spin size="large" />
                        </div>}
                    {"loaded" === this.state.pageStatus &&
                        <Table columns={this.columns}
                            dataSource={this.state.data.Data}
                            rowSelection={this.rowSelection}
                            rowKey={record => record.id}
                            pagination={{
                                total: this.state.data.Total,
                                pageSize: this.state.data.PageSize,
                                current: this.state.filters.page
                            }}
                            onChange={this.setPageFilter} />}
                </div>
                <Modal width="800px"
                    visible={this.state.modalVisible}
                    title={this.state.modelName}
                    destroyOnClose={true}
                    onCancel={this.toggleModal}
                    onOk={this.submitCurrentData}>
                    <div style={{ textAlign: "center", margin: "0px 0px 5px", overflowY: "auto" }}>
                        <Form className="login-form" layout="inline">
                            <div>
                                <Form.Item label="群组名称">
                                    {this.props.form.getFieldDecorator('name', {
                                        rules: [],
                                        initialValue: this.state.currentData.name
                                    })(<Input style={{ width: "300px", color: "black" }} />)}
                                </Form.Item>
                            </div>
                            <div>
                                <Form.Item label={(
                                    <span>
                                        <Tooltip>
                                            <Icon type="team" />
                                        </Tooltip>
                                        &nbsp;部门查找
				            </span>
                                )}>
                                    {this.props.form.getFieldDecorator('department_id', {
                                        rules: [{ required: true, message: '请选择部门' }],
                                    })(<TreeSelect style={{ width: "360px" }}
                                        allowClear
                                        placeholder="请选择部门"
                                        showSearch={false}
                                        autoExpandParent={true}
                                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                        treeDefaultExpandAll>
                                        {this.renderTreeNodes(this.state.department)}
                                    </TreeSelect>)}
                                </Form.Item>
                            </div>
                        </Form>
                    </div>
                </Modal>
            </div>
        )
    }

}

const mapStateToProps = state => {
    return {
        departmentStructure: state.departmentStructure,
    }
}
const mapDispatchToProps = {
	fetchDepartmentsList
}



TraningGroup = Form.create()(TraningGroup);

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(TraningGroup));


// WEBPACK FOOTER //
// ./src/routes/Training/TraningGroup.js